import { render, staticRenderFns } from "./form-item.vue?vue&type=template&id=667520b4&scoped=true"
import script from "./form-item.vue?vue&type=script&lang=ts"
export * from "./form-item.vue?vue&type=script&lang=ts"
import style0 from "./form-item.vue?vue&type=style&index=0&id=667520b4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667520b4",
  null
  
)

export default component.exports